import { Tab, Tabs } from '@mui/material'
import { Link } from 'react-router-dom'

export const CorporateAccountDetailsPageTabs = ({
  corporateAccountId,
  currentTab,
}: {
  corporateAccountId: number
  currentTab: string
}) => {
  return (
    <Tabs value={currentTab}>
      <Tab
        label="Overview"
        value={`/ClientManagement/CorporateAccounts/${corporateAccountId}/CorporateAccountOverview`}
        to={`/ClientManagement/CorporateAccounts/${corporateAccountId}/CorporateAccountOverview`}
        component={Link}
      />
      <Tab
        label="Associated Accounts"
        value={`/ClientManagement/CorporateAccounts/${corporateAccountId}/CorporateAccountAssociatedAccounts`}
        to={`/ClientManagement/CorporateAccounts/${corporateAccountId}/CorporateAccountAssociatedAccounts`}
        component={Link}
        sx={{
          whiteSpace: 'nowrap',
        }}
      />
      <Tab
        label="J&J Connect Users"
        value={`/ClientManagement/CorporateAccounts/${corporateAccountId}/CorporateAccountLEUsers`}
        to={`/ClientManagement/CorporateAccounts/${corporateAccountId}/CorporateAccountLEUsers`}
        component={Link}
        sx={{
          whiteSpace: 'nowrap',
        }}
      />
      <Tab
        label="Specials & Events"
        value={`/ClientManagement/CorporateAccounts/${corporateAccountId}/CorporateAccountSpecialsEvents`}
        to={`/ClientManagement/CorporateAccounts/${corporateAccountId}/CorporateAccountSpecialsEvents`}
        component={Link}
        sx={{
          whiteSpace: 'nowrap',
        }}
      />
    </Tabs>
  )
}
